export const THIRD_PARTY_LOGIN_PROVIDERS = [
  'google',
  'microsoft'
]



// WEBPACK FOOTER //
// ./src/constants/loginConstants.js